var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaymentgateways = function SvgPaymentgateways(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 4.18629L14 7.88702C14 8.91189 13.1999 9.7499 12.1903 9.81057L12.0729 9.81408H1.92757C0.902699 9.81408 0.0646903 9.01403 0.00402143 8.00441L0.000504391 7.88702L0 4.18629H13.9996ZM11.382 6.64263H9.63013L9.55881 6.64743C9.30228 6.68223 9.10457 6.90212 9.10457 7.16819C9.10457 7.43426 9.30228 7.65416 9.55881 7.68896L9.63013 7.69375H11.382L11.4533 7.68896C11.7099 7.65416 11.9076 7.43426 11.9076 7.16819C11.9076 6.90212 11.7099 6.68223 11.4533 6.64743L11.382 6.64263ZM12.0729 0C13.0978 0 13.9358 0.800051 13.9965 1.80967L14 1.92707L13.9996 3.13516H0L0.000504391 1.92707C0.000504391 0.902195 0.800555 0.0641858 1.81018 0.00351687L1.92757 0H12.0729Z",
    fill: "#212121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentgateways, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment gateways.5134a7f2.svg";
export { ForwardRef as ReactComponent };